import React from 'react';
import {
  Bottom,
  BottomContent,
  Box,
  Circle,
  Content,
  Content1,
  Div,
  Left,
  LeftLine,
  Main,
  Right,
  Top,
  User,
  Users
} from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';

export default function MilestoneLoading() {
  return (
    <Main>
      <Box>
        <Content>
          <Top>
            <Left>
              <Div>
                <Circle className='loading-animation'></Circle>
              </Div>
              <LeftLine className='loading-animation'></LeftLine>
            </Left>
            <Right>
              <Users>
                <User className='loading-animation' />
                <User className='loading-animation' />
                <User className='loading-animation' />
                <User className='loading-animation' />
              </Users>
              <SVGIcon
                className='dot-icon'
                name='new-three-dots-vertical-icon'
                width={ICON_SIZE.XXL}
                height={ICON_SIZE.XXL}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              />
            </Right>
          </Top>
          <Bottom className='loading-animation'></Bottom>
        </Content>
      </Box>
      <Box>
        <Content1>
          <Top>
            <Left>
              <Div>
                <Circle className='loading-animation'></Circle>
              </Div>
              <LeftLine className='loading-animation'></LeftLine>
            </Left>
            <Right>
              <Users>
                <User className='loading-animation' />
                <User className='loading-animation' />
                <User className='loading-animation' />
                <User className='loading-animation' />
              </Users>
              <SVGIcon
                className='dot-icon'
                name='new-three-dots-vertical-icon'
                width={ICON_SIZE.XXL}
                height={ICON_SIZE.XXL}
                viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              />
            </Right>
          </Top>
          <Bottom className='loading-animation'></Bottom>
          <BottomContent>
            <Left className='first'>
              <Div>
                <Circle className='loading-animation'></Circle>
              </Div>
              <LeftLine className='first-line loading-animation'></LeftLine>
            </Left>
            <Left>
              <Div>
                <Circle className='loading-animation'></Circle>
              </Div>
              <LeftLine className='second-line loading-animation'></LeftLine>
            </Left>
            <Left>
              <Div>
                <Circle className='loading-animation'></Circle>
              </Div>
              <LeftLine className='third-line loading-animation'></LeftLine>
            </Left>
            <Left>
              <Div>
                <Circle className='loading-animation'></Circle>
              </Div>
              <LeftLine className='forth-line loading-animation'></LeftLine>
            </Left>
          </BottomContent>
        </Content1>
      </Box>
    </Main>
  );
}
